<template>
  <div class="study-page">
    <h1>留学服务</h1>

    <section class="school-intro" @click="$router.push('/study/school-intro')">
      <h2>院校介绍</h2>
      <div class="content">
        <p>一、加拿大大学的类别划分：加拿大高等教育在全世界处于领先水平，其教育质量受到世界的广泛认可。一方面归功于一流的教育质量，另一方面归功于公立教育体制。因为加拿大的高等教育机构以及发展规划上都受到了政府的投入和监督。加拿大著名的Maclean's 杂志在大学排名中，把加拿大的大学分为三类：分别为医博大学（Medical & Doctoral）、综合类大学（Comprehensive）、和基础类大学（Primarily undergraduate）。</p>
      </div>
    </section>

    <section class="application-process" @click="$router.push('/study/school-application')">
      <h2>院校申请</h2>
      <div class="content">
        <p>留学准备的第一步，就是要根据你的综合条件和确定你的留学方向，即明确哪些学校和专业可以申请？该考个专业？无论你的经济能力大小，只要具备一定基础，合理规划，都能找到适合自己的学校和专业。让参考我们，面对众多的加拿大院校和专业该怎么选呢？必须要先了解不同的学校情况及专业才能做出正确的选择。</p>
      </div>
    </section>

    <section class="document-guide" @click="$router.push('/study/document-guidance')">
      <h2>文书指导</h2>
      <div class="content">
        <p>在申请加拿大大学时，准备一份优秀的申请文书至关重要的。加拿大的大学通常会看看每个申请人的综合素质和个人特色，因此文书的撰写需要注意展示个人的全面能力和特色之处。文书主要包括以下几个方面：CV/Resume（简历）、Reference Letter（推荐信）、Essay论文以及Personal Statement个人陈述、CV/Resume个人简历。</p>
      </div>
    </section>

    <section class="language-test" @click="$router.push('/study/ielts-training')">
      <h2>雅思托福考试培训</h2>
      <div class="content">
        <p>标准化考试成绩是大学录取时非常看重的一项内容，它展示了学生的语言交流能力，对于进入大学后快速适应学习环境。扩大学的优势专业往往对语言的要求非常严格，如果没有好的语言成绩很难被录取。标准化语言考试进行系统的学习和训练，这样能更好的掌握考试要求并达到自己的优势竞争能力，通过针对性的教学方案来帮助学生更好一定的学习方法。帮助巩固、熟练掌握，在制定的时间内完成培训的同时提高自己的能力。</p>
      </div>
    </section>

    <section class="interview-guide" @click="$router.push('/study/interview-guidance')">
      <h2>面试辅导</h2>
      <div class="content">
        <p>在加拿大的大学本科的申请过程中，一些商科和工程专业会要求学生进行视频面试，面试校方会通过这些视频来考察学生的个人兴趣爱好，判断思考能力，在面临压力时的表现，和英语口语的熟练度。不同于一般的人人面试，录制视频面试题目时间一般会限制在30-60秒的时间内对于每道题进行回答，每个人面试作答时间不能超过60-120秒的时间，这有点人面试作答时间不能重复录制，并且只有一次机会不能重新录制。对大部分学生的临场发挥能力和应对压力的能力是一种挑战。</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'StudyView'
}
</script>

<style lang="less" scoped>
.study-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    text-align: center;
    margin-bottom: 40px;
    color: #333;
    font-size: 32px;
    font-weight: bold;
  }

  section {
    margin-bottom: 40px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    padding: 35px;
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }

    h2 {
      color: #e63946;
      margin-bottom: 25px;
      font-size: 26px;
      font-weight: bold;
      position: relative;
      padding-left: 15px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 20px;
        background: #e63946;
        border-radius: 2px;
      }
    }

    .content {
      p {
        color: #333;
        line-height: 1.8;
        margin-bottom: 25px;
        text-align: justify;
        font-size: 16px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .study-page {
    padding: 20px;

    h1 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    section {
      padding: 25px;

      h2 {
        font-size: 22px;
      }
    }
  }
}
</style>